import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { Router } from "@angular/router";

import { DocumentationRoutesConstants } from "@features/documentation/routes/documentation.routes.constants";
import { CustomIconComponent } from "@shared/components/custom-icon/custom-icon.component";
import { BaseModalComponent } from "@shared/components/modal/base-modal.component";
import { ModalComponent } from "@shared/components/modal/modal.component";

@Component({
  selector: "component-thank-you-for-purchase-modal",
  templateUrl: "./thank-you-for-purchase-modal.component.html",
  styleUrls: ["./thank-you-for-purchase-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ModalComponent, CustomIconComponent]
})
export class ThankYouForPurchaseModalComponent extends BaseModalComponent {
  private readonly _router = inject(Router);

  protected onContinue(): void {
    this.activeModal.close();
    this._router.navigate([DocumentationRoutesConstants.main()]);
  }
}
